import React from 'react';

import './CTA.scss'

const CTA = props => {
    const thumbnailClass = [
        'dynamic-content-asset-thumbnail',
        `thumbnail-${props.classAdd}`
    ];

    return (
        <div className="dynamic-content-asset">
            <div className={thumbnailClass.join(' ')}></div>
            <div className="dynamic-content-asset-content">
                <div className="dynamic-content-asset-label">{props.title}</div>
                <div className="dynamic-content-asset-text">{props.description}</div>
                <a rel='noreferrer' className="btn dynamic-content-asset-btn" href={props.url} target="_blank">{props.text}</a>
            </div>
        </div>
    )

}

export default CTA;